import { Navigate } from '@tanstack/react-router';

const Auth = () => {
  return <Navigate to="/" replace />;
};

export default Auth;
